const unEscape = (htmlStr) => {
  htmlStr = htmlStr.replace(/&laquo;/g, "<");
  htmlStr = htmlStr.replace(/&raquo;/g, ">");
  return htmlStr;
};

export default unEscape;
